import { useState, useEffect } from 'react'

// Components
import { Radio } from 'components/form/inputs'
import { Button, IconCheck, IconPen } from '@tracklib/kit'

// Utils
import styles from './publishingowner.css'

type PublishingOwnerProps = {
  onReview: boolean
  publishingOwner: string
}

const PublishingOwner = (props: PublishingOwnerProps): JSX.Element => {
  const { onReview, publishingOwner } = props
  const [isEditing, setIsEditing] = useState(true)

  useEffect(() => {
    if (onReview) {
      setIsEditing(false)
    }
  }, [onReview])

  const humanReadablePublishingOwner = () => {
    const SELF_OWNED = 'I own and control my own publishing'
    const EXTERNAL_OWNED = 'I own part of the publishing but there are also external publishers involved'

    return publishingOwner === 'self_owned' ? SELF_OWNED : EXTERNAL_OWNED
  }

  if (!isEditing) {
    return (
      <div className={styles.displayWrapper}>
        <div className={styles.textData}>{humanReadablePublishingOwner()}</div>
        {onReview && !isEditing && (
          <Button className={styles.btnEdit} variant="outline" onClick={() => setIsEditing(!isEditing)}>
            <IconPen />
          </Button>
        )}
      </div>
    )
  }

  return (
    <div className={styles.editingWrapper}>
      <div className={styles.radioOptionsWrapper}>
        <Radio className={styles.listItem} id="self_owned" name="publishing_owner" size="large" value="self_owned">
          <span className={styles.listItemText}>I own and control my own publishing</span>
        </Radio>
        <Radio
          className={styles.listItem}
          id="self_and_external_owned"
          name="publishing_owner"
          size="large"
          value="self_and_external_owned"
        >
          <span className={styles.listItemText}>I own part of the publishing but there are also external publishers involved</span>
        </Radio>
        <Radio
          className={styles.listItem}
          id="self_and_publishing_administrator"
          name="publishing_owner"
          size="large"
          value="self_and_publishing_administrator"
        >
          <span className={styles.listItemText}>I own my own compositions but have a publishing administrator</span>
        </Radio>
        <Radio className={styles.listItem} id="unpublished" name="publishing_owner" size="large" value="unpublished">
          <span className={styles.listItemText}>My music is unpublished (I have not registered publishing for my catalog)</span>
        </Radio>
        <Radio className={styles.listItem} id="external_owned" name="publishing_owner" size="large" value="external_owned">
          <span className={styles.listItemText}>Someone else owns the compositions/publishing of my catalog</span>
        </Radio>
      </div>
      {onReview && isEditing && (
        <Button className={styles.btnEditConfirm} onClick={() => setIsEditing(!isEditing)}>
          <IconCheck />
        </Button>
      )}
    </div>
  )
}

export default PublishingOwner
